<template>
  <div v-if="selectedSubCategory !== null" class="container">
    <h1 class="section-title" style="text-align: center; margin-top: 50px;">
      {{ selectedSubCategory.movieSubcategory.name }}
    </h1>
    <return-btn
      :path="
        isExtendedSubscription
          ? 'subskrypcja-rozszerzona'
          : selectedSubCategory &&
            selectedSubCategory.movieSubcategory &&
            selectedSubCategory.movieSubcategory.forBeginners
          ? 'subskrypcja-podstawy'
          : `subskrypcja`
      "
      blackColor
    ></return-btn>
    <div class="content">
      <div class="description">
        <!-- <h1>{{ selectedSubCategory.movieSubcategory.name }}</h1> -->
        <p
          class="description-text"
          v-html="selectedSubCategory.movieSubcategory.description"
        ></p>
      </div>
      <div class="category-image">
        <img id="subcategory-view-image" loading="lazy" />
        <div
          class=""
          style="color:#6D6963; font-weight: 600; margin-right: 10px;"
        >
          {{ selectedSubCategory.movieSubcategory.name }}
          <svg
            width="101"
            height="16"
            viewBox="0 0 101 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100.707 8.70711C101.098 8.31658 101.098 7.68342 100.707 7.29289L94.3431 0.928932C93.9526 0.538408 93.3195 0.538408 92.9289 0.928932C92.5384 1.31946 92.5384 1.95262 92.9289 2.34315L98.5858 8L92.9289 13.6569C92.5384 14.0474 92.5384 14.6805 92.9289 15.0711C93.3195 15.4616 93.9526 15.4616 94.3431 15.0711L100.707 8.70711ZM0 9L100 9V7L0 7L0 9Z"
              fill="#6D6963"
            />
          </svg>
        </div>
      </div>
    </div>
    <div class="" style="display: flex; justify-content: center; align-items: center;">
    <div class="courses">
      <Course
        v-for="timePackageItem in subcategoryItems"
        :timePackageItem="timePackageItem"
        :key="timePackageItem.id"
        :id="`course_${timePackageItem.id}`"
        :selectedSubCategoryId="selectedSubCategory.movieSubcategory.id"
        :numberOfTimePackageItems="selectedSubCategory.numberOfTimePackageItems"
        :isExtendedSubscription="isExtendedSubscription"
      >
      </Course>
    </div>
    </div>
  </div>
</template>

<script>
// import moment from "moment";
// import Category from "../components/Category.vue";
// import Package from "../components/Package.vue";
// import Telegram from "../components/Telegram.vue";
import router from "../router";
// import MovieSubcategory from "../components/MovieSubcategory.vue";
import Course from "../components/Course.vue";
import ReturnBtn from "../components/ReturnBtn.vue";
import { SERVER_URL } from "../axios";
export default {
  metaInfo: {
    title: "Dagajoga subskrypcja - portal jogi online",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Dagajoga to szkoła internetowa o wszechstronnym systemie budowania praktyki własnej. Praktyka jogi połączona z nowoczesnymi metodami ćwiczeń funkcjonalnych, ćwiczeń wzmacniających.",
      },
    ],
  },
  name: "SubcategoryView",
  data: () => ({ fetched: true, img: "", isExtendedSubscription: false }),
  components: { Course, ReturnBtn },
  props: {
    path: String,
  },

  async mounted() {
    const id = router.currentRoute.params.id;
    if (this.$route.query.rozszerzona && this.$route.query.rozszerzona == "1") {
      this.isExtendedSubscription = true;
    }
    if (
      this.selectedSubCategory &&
      this.selectedSubCategory.movieSubcategory &&
      this.selectedSubCategory.movieSubcategory.imagePath
    ) {
      this.loadImage(this.selectedSubCategory.movieSubcategory);
    } else {
      this.img = await this.$store.dispatch(
        "movieSubCategories/getSubCategoryImageSrc",
        { subCategoryId: router.currentRoute.params.id }
      );
    }
    if (!this.isExtendedSubscription) {
      await this.$store.dispatch(
        "timePackages/fetchAllTimePackageItemsBySubCategoryId",
        id
      );
    } else {
      await this.$store.dispatch(
        "timePackages/fetchAllTimePackageItemsExtendedBySubCategoryId",
        id
      );
    }
    if (this.selectedSubCategory === null) {
      await this.$store.dispatch("movieCategories/fetchAllForUser");
      this.$store.getters["movieCategories/getMovieCategories"].forEach(
        (course) => {
          course.movie_sub_categories.forEach((subcourse) => {
            if (subcourse.id === id) {
              this.$store.dispatch(
                "movieSubCategories/setSelectedMovieSubCategory",
                {
                  movieSubcategory: subcourse,
                }
              );
            }
          });
        }
      );
    }
  },

  computed: {
    token() {
      return this.$store.getters["auth/getToken"];
    },
    subcategoryItems() {
      return this.$store.getters["timePackages/getSubCategoryTimePackageItems"];
    },
    selectedSubCategory() {
      return this.$store.getters[
        "movieSubCategories/getSelectedMovieSubCategory"
      ];
    },
  },
  methods: {
    async loadImage(subCategory) {
      const element = document.getElementById("subcategory-view-image");
      if (element) {
        if (subCategory.imagePath) {
          const extension = subCategory.imagePath.split(".")[1];
          element.src = `${SERVER_URL}${
            subCategory.id
          }.${extension}?${new Date().getTime()}`;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
}
.content {
  color: #000;
  margin: 40px 0;
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-direction: row;
  margin-bottom: 60px;
}
.content {
  h1 {
    font-size: 2rem;
    margin: 0 1rem;
  }
  p {
    font-size: 1rem;
    margin: 0 1rem;
  }
}

.courses {
  width: fit-content;
  max-width: 950px;
  display: flex;
  flex-wrap: wrap;
  gap: 40px 100px;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  margin-bottom: 4rem;
}
.content img,
.content div {
  width: 50%;
}

.description p {
  color: #54514c;
}

.category-image img {
  width: 520px;
  height: 300px;
  object-fit: cover;
  border-radius: 17px;
}
@media (max-width: 1080px) {
  .content {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

@media (max-width: 600px) {
  .content img,
  .content div {
    width: 100%;
  }
}
</style>
